import { db, app, auth } from "../firebase_setup";

import { useAuth } from "../context/DBContext"
// import {useState } from "react";


export async function createOneTimeCheckoutSession(currentUser, serviceId, timeSlotId, childId = null) {
  try {
    // Fetch the service to get the Stripe Price ID
    const serviceDoc = await db.collection('services').doc(serviceId).get();
    if (!serviceDoc.exists) {
      throw new Error('Service not found');
    }
    const serviceData = serviceDoc.data();
    const priceId = serviceData.stripePriceId;

    if (!priceId) {
      throw new Error('Price ID not found for this service');
    }

    // **Pass metadata and client_reference_id**
    const docRef = await db.collection('users').doc(currentUser.uid).collection('checkout_sessions').add({
      mode: 'payment',
      price: priceId,
      success_url: `${window.location.origin}/dashboard`,
      cancel_url: `${window.location.origin}/dashboard`,
      allow_promotion_codes: true, // Enable promotion code entry for one-time payments
      metadata: {
        serviceId: serviceId,
        timeSlotId: timeSlotId,
        childId: childId, // Changed from childIndex
      },
      client_reference_id: `${serviceId}_${timeSlotId}${childId ? `_child_${childId}` : ''}`, // Updated reference format
    });

    // Listen for the CheckoutSession to get updated by the extension
    docRef.onSnapshot((snap) => {
      const { error, url } = snap.data();
      if (error) {
        alert(`An error occurred: ${error.message}`);
      }
      if (url) {
        // Redirect to Stripe Checkout
        window.location.assign(url);
      }
    });
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
}


export async function createCheckoutSession(currentUser, priceID) {


  // console.log("role is: " + await GetCustomClaimRole());
  if (await GetCustomClaimRole() != "inactive") {
    return createManagePortal();
  }

  const docRef = await db
    .collection('users')
    .doc(currentUser.uid)
    .collection('checkout_sessions')
    .add({
      price: priceID,
      success_url: `${window.location.origin}/dashboard`,
      cancel_url: `${window.location.origin}/dashboard`,
      allow_promotion_codes: true, // Enable promotion code entry
      trial_period_days: 14, // Set trial period (adjust as needed)
    })
    .then((docRef) => {
      // Wait for the CheckoutSession to get attached by the extension
      docRef.onSnapshot((snap) => {
        const { error, url } = snap.data();
        if (error) {
          // Show an error to your customer and
          // inspect your Cloud Function logs in the Firebase console.
          alert(`An error occurred: ${error.message}`);
        }
        if (url) {
          // We have a Stripe Checkout URL, let's redirect.
          window.location.assign(url);
        }
      });
    })
    .catch((error) => {
      // Handle any errors that occur during the checkout session creation.
      alert(`An error occurred: ${error.message}`);
    });
}

export const fetchActiveSubscription = (currentUser, setSubscriptionStatus) => {
    return db
      .collection('customers')
      .doc(currentUser.uid)
      .collection('subscriptions')
      .where('status', 'in', ['trialing', 'active'])
      .onSnapshot((snapshot) => {
        // In this implementation we only expect one active or trialing subscription to exist.
        const doc = snapshot.docs[0];
        
        if (doc) {
          setSubscriptionStatus(doc.data().status);
        } else {
          setSubscriptionStatus("inactive");
        }
      });
  };


  export async function GetCustomClaimRole() {
    
    try {
      await auth.currentUser.getIdToken(true);
      const decodedToken = await auth.currentUser.getIdTokenResult();
      return decodedToken.claims.stripeRole || "inactive";
    } catch (error) {
      console.error("Error getting custom claim role:", error);
      return "inactive";
    }
  }
  
export const createManagePortal = async () => {
    try {
      // console.log("creating portal..");
      const returnUrl = `${window.location.origin}/dashboard`;
  
      const functionRef = 
        app
        .functions('us-central1')
        .httpsCallable('ext-firestore-stripe-payments-createPortalLink');
  
      const { data } = await functionRef({
        returnUrl: returnUrl
      //   locale: 'auto', // Optional, defaults to "auto"
      //   configuration: 'bpc_1JSEAKHYgolSBA358VNoc2Hs', // Optional ID of a portal configuration
      });
  
      window.location.assign(data.url);
  
    } catch (error) {
      console.error('An error occurred while creating the manage portal:', error);
      // Handle error as needed
    }
  };
  
  
